"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listen = exports.getSupportedTypes = void 0;
var capabilities_1 = require("@nextcloud/capabilities");
var axios_1 = require("@nextcloud/axios");
var event_bus_1 = require("@nextcloud/event-bus");
/**
 * Get the list of supported notification types as reported by the server
 *
 * @return string[]
 */
function getSupportedTypes() {
    var capabilities = capabilities_1.getCapabilities();
    if (capabilities.notify_push) {
        return capabilities.notify_push.type;
    }
    else {
        return [];
    }
}
exports.getSupportedTypes = getSupportedTypes;
/**
 * Register a listener for notify_push events
 *
 * @param name name of the event
 * @param handler callback invoked for every matching event pushed
 * @return boolean whether or not push is setup correctly
 */
function listen(name, handler) {
    setupGlobals();
    if (!window._notify_push_listeners[name]) {
        window._notify_push_listeners[name] = [];
    }
    window._notify_push_listeners[name].push(handler);
    if (window._notify_push_ws !== null && typeof window._notify_push_ws === "object") {
        window._notify_push_ws.send('listen ' + name);
    }
    else {
        setupSocket();
    }
    return window._notify_push_available;
}
exports.listen = listen;
function setupGlobals() {
    if (typeof window._notify_push_listeners === "undefined") {
        window._notify_push_listeners = {};
        window._notify_push_ws = null;
        window._notify_push_online = true;
        window._notify_push_available = false;
        event_bus_1.subscribe('networkOffline', function () {
            window._notify_push_online = false;
            window._notify_push_ws = null;
        });
        event_bus_1.subscribe('networkOnline', function () {
            window._notify_push_online = true;
            setupSocket();
        });
    }
}
function setupSocket() {
    return __awaiter(this, void 0, void 0, function () {
        var capabilities, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window._notify_push_ws) {
                        return [2 /*return*/, true];
                    }
                    window._notify_push_ws = true;
                    capabilities = capabilities_1.getCapabilities();
                    if (!capabilities.notify_push) {
                        window._notify_push_available = false;
                        window._notify_push_ws = null;
                        return [2 /*return*/, false];
                    }
                    window._notify_push_available = true;
                    return [4 /*yield*/, axios_1.default.post(capabilities.notify_push.endpoints.pre_auth)];
                case 1:
                    response = _a.sent();
                    window._notify_push_ws = new WebSocket(capabilities.notify_push.endpoints.websocket);
                    window._notify_push_ws.onopen = function () {
                        if (typeof window._notify_push_ws === "object" && window._notify_push_ws) {
                            window._notify_push_ws.send('');
                            window._notify_push_ws.send(response.data);
                            for (var name_1 in window._notify_push_listeners) {
                                window._notify_push_ws.send('listen ' + name_1);
                            }
                        }
                    };
                    window._notify_push_ws.onmessage = function (message) {
                        var i = message.data.indexOf(' ');
                        var _a = i > 0 ? [message.data.slice(0, i), message.data.slice(i + 1)] : [message.data, null], event = _a[0], body = _a[1];
                        if (body) {
                            body = JSON.parse(body);
                        }
                        if (window._notify_push_listeners[event]) {
                            for (var _i = 0, _b = window._notify_push_listeners[event]; _i < _b.length; _i++) {
                                var cb = _b[_i];
                                cb(event, body);
                            }
                        }
                    };
                    window._notify_push_ws.onerror = window._notify_push_ws.onclose = function () {
                        window._notify_push_ws = null;
                        setTimeout(function () {
                            if (window._notify_push_online) {
                                setupSocket();
                            }
                        }, 1000);
                    };
                    return [2 /*return*/, true];
            }
        });
    });
}
